import { CustomerType, MachineType } from "operations/schema/schema";

export const HistoryFilterStorageKey = "historyFilter";
export const ServiceHistoryFilterStorageKey = "serviceHistoryFilter";
export const SearchHistoryFilterStorageKey = "searchHistoryFilter";

const StorageKeys = [HistoryFilterStorageKey, ServiceHistoryFilterStorageKey] as const;
export type HistoryFilterStorageTypes = (typeof StorageKeys)[number];

export type HistoryFilterDateTypes =
  | "week"
  | "1month"
  | "12month"
  | "24month"
  | "5year"
  | "specificDate";
export type HistoryFilter = {
  typeDate: HistoryFilterDateTypes;
  specificDate: Date | null;
};

export const defaultHistoryFilter: HistoryFilter = {
  typeDate: "week",
  specificDate: null,
};

export const defaultServiceHistoryFilter: HistoryFilter = {
  typeDate: "12month",
  specificDate: null,
};

export type SearchHistoryFilter = {
  customer: CustomerType | null;
  machine: MachineType | null;
  typeDate: HistoryFilterDateTypes;
  specificDate: Date | null;
};

export const defaultSearchHistoryFilter: SearchHistoryFilter = {
  customer: null,
  machine: null,
  typeDate: "1month",
  specificDate: null,
};

const keysToExclude = ["specificDate", "typeDate"] as const;
type FilterKeys = (keyof Omit<typeof defaultHistoryFilter, (typeof keysToExclude)[number]>)[];
export const HistoryFilterKeys: FilterKeys = Object.keys(defaultHistoryFilter).filter(
  (x) => !keysToExclude.includes(x as any)
) as FilterKeys;
export const ServiceHistoryFilterKeys: FilterKeys = Object.keys(defaultServiceHistoryFilter).filter(
  (x) => !keysToExclude.includes(x as any)
) as FilterKeys;
export const SearchHistoryFilterKeys: FilterKeys = Object.keys(defaultSearchHistoryFilter).filter(
  (x) => !keysToExclude.includes(x as any)
) as FilterKeys;
